export default __webpack_public_path__ + "static/media/prod-img-2.43797293.webp";